import { aboutData } from '@/mocks/about';

export default function BrandIntro() {
  const { brandIntro } = aboutData;

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4 whitespace-nowrap">
            {brandIntro.subtitle}
          </span>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {brandIntro.title}
          </h1>
          <p className="text-foreground-500 text-sm max-w-2xl mx-auto leading-relaxed">
            {brandIntro.description}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-12">
          {brandIntro.stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-6 rounded-xl bg-background-100 border border-background-200/70"
            >
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                {stat.value}
              </p>
              <p className="text-foreground-500 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-4">
              <i className="ri-flag-line text-primary-600 text-lg"></i>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-2">我们的使命</h3>
            <p className="text-foreground-500 text-sm leading-relaxed">{brandIntro.mission}</p>
          </div>
          <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
              <i className="ri-eye-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 mb-2">我们的愿景</h3>
            <p className="text-foreground-500 text-sm leading-relaxed">{brandIntro.vision}</p>
          </div>
        </div>
      </div>
    </section>
  );
}